/**
 * The keyboard-shortcut sheet (spec M0-F4 §7.9, K2).
 *
 * It renders itself from the registry, so it cannot drift: a binding that is not in
 * `SHORTCUTS` does not appear, and one that is appears exactly once.
 */
import { Heading } from '@elizmonday/ui';
import { renderBinding, shortcutGroups } from '../../modules/shell/shortcuts';

export function ShortcutSheet() {
  return (
    <div
      className="ez-shortcut-sheet"
      role="dialog"
      aria-modal="true"
      aria-label="Keyboard shortcuts"
      data-testid="shortcut-sheet"
      onClick={(event) => event.stopPropagation()}
    >
      {/* monday's own title and hint, verbatim `[c:shortcuts]`. */}
      <Heading type="h2" element="h1">
        Keyboard Shortcuts
      </Heading>
      <p className="ez-shortcut-sheet__hint">
        <kbd className="ez-kbd">Shift</kbd> <kbd className="ez-kbd">?</kbd> to open this menu
      </p>
      {shortcutGroups().map((group) => (
        <section key={group.group}>
          <h2 className="ez-shortcut-sheet__group-title">{group.group}</h2>
          {group.shortcuts.map((shortcut) => (
            <div key={shortcut.id} className="ez-shortcut-sheet__row" data-shortcut-id={shortcut.id}>
              <span>{shortcut.description}</span>
              <span className="ez-shortcut-sheet__keys">
                {shortcut.keys.map((binding) => (
                  <kbd key={binding} className="ez-kbd">
                    {renderBinding(binding)}
                  </kbd>
                ))}
              </span>
            </div>
          ))}
        </section>
      ))}
    </div>
  );
}
